"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { useMediaQuery } from "@workspace/frontend-ui";
import type { FC } from "react";
import DesktopAuthDialog from "./DesktopAuthDialog";
import MobileAuthDrawer from "./MobileAuthDrawer";

type Props = {
  open?: boolean;
};

const LoginAreaPopover: FC<Props> = ({ open }) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const { setAuthModalVisible, authTab, t } = useGamePageData();
  const dialogTitle = t("game.auth.dialogtitle", "Login or register");
  const dialogDescription = t(
    "game.auth.dialogdescription",
    "Sign in to your account or create a new one to keep playing.",
  );

  // A hard reload, not router.refresh(): every piece of server state must pick up fresh.
  const handleSuccess = () => {
    setAuthModalVisible(false);
    window.location.reload();
  };

  const sharedProps = {
    open,
    onOpenChange: setAuthModalVisible,
    authTab,
    onSuccess: handleSuccess,
    dialogTitle,
    dialogDescription,
  };

  if (isDesktop) {
    return <DesktopAuthDialog {...sharedProps} />;
  }
  return <MobileAuthDrawer {...sharedProps} />;
};

export default LoginAreaPopover;
